module.exports = __webpack_public_path__ + "img/NewOrleans-cover.76059f19.jpg";